<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-mins-third-party-liability.svg" />{{ title }}
						</h2>
						<p>
							<b>{{ intro }}</b>
						</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "THIRD PARTY LIABILITY",
			intro: "The Company shall answer for the sums that the Insured Party is required to pay, as the civilly liable party under law, as compensation (principal, interest and expenses) for harm caused involuntarily to third parties including death, personal injury and damage to objects and animals as a consequence of an accidental event taking place during travel relating to events in the private sphere and relating to professional activity while you are working for Insured Companies.",
			coverages: [
				{
					title: "THIRD PARTY LIABILITY",
					chapters: [
						{
							title: "",
							text: "All bodily injury, property and consequential losses.  Coverage also includes damage caused by:<ul><li>pets</li><li>the ownership and use of cycles, non-motorised vehicles and boats no longer than 6.5 meters, golf carts</li><li>playing sports, including races, not at the professional level, leisure activities and camping.</li></ul>",
							limit: "€ 250.000 (per Claim and annual aggregate)"
						},
					]
				},
				{
					title: "CAR HIRE EXCESS",
					chapters: [
						{
							title: "",
							text: "expenses that the Insured Party may be required to pay as a civilly liable party for damage caused to a rental vehicle (exceeding the amount paid by the insurance coverage on the vehicle itself.",
							limit: "€ 1.000 (per Claim and annual aggregate)"
						},
					]
				},
			]
		}
	}
}
</script>
